<template>
  <div>
    <div class='top'>添加学生</div>
    <van-cell-group>
      <div class='info-name-field'>
        <van-field v-model="name" required clearable label="姓名" placeholder="请输入姓名" />
        <div class='field-sel' @click='showName = true'>选择</div>
      </div>
      <van-field name='sex' label='性别' required readonly>
        <template #input>
          <van-radio-group v-model='gender' direction='horizontal'>
            <van-radio name='0' checked-color='#5CC4AB'>男</van-radio>
            <van-radio name='1' checked-color='#5CC4AB'>女</van-radio>
            <van-radio name='2' checked-color='#5CC4AB'>未知</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model='birth' label='出生日期' readonly clickable placeholder='请选择出生日期' @click='showBirth = true'
        required />
      <van-field v-model='archivesDate' label='建档日期' readonly clickable placeholder='请选择建档日期' @click='showArchives = true'
        required />

      <van-field required v-model="phone" type="number" clearable label="手机号" placeholder="请输入手机号" />
      <van-button type="info" @click="goQuery" class="btn">
        下一步
      </van-button>
    </van-cell-group>
    <van-popup v-model='showName' position='bottom'>
      <van-picker :columns='listName' show-toolbar value-key='name' cancel-button-text='取消' confirm-button-text='确定'
        @cancel='showName = false' @confirm='onConfirmName' />
    </van-popup>
    <van-popup v-model='showBirth' position='bottom'>
      <van-datetime-picker :min-date='minDate' v-model='currentDate' type='date' @cancel='showBirth = false'
        @confirm='onConfirmBirth' />
    </van-popup>
    <van-popup v-model='showArchives' position='bottom'>
      <van-datetime-picker :min-date='minDate' v-model='currentDate1' type='date' @cancel='showArchives = false'
        @confirm='onConfirmArchives' />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'query',
  data() {
    return {
      showName: false,
      listName: [],
      name: '',
      phone: '',
      gender: '0',
      birth: '',
      archivesDate: '',
      minDate: new Date(1950, 0, 1),
      openId: '',
      showBirth: false,
      showArchives: false,
      currentDate: new Date(new Date().getTime()),
      currentDate1: new Date(new Date().getTime()),
    };
  },
  mounted() {
    this.openId = this.$route.query.openId;
    this.accountId = this.$route.query.accountId;
    this.shortId = this.$route.query.shortId;
    this.getTitle();
    this.getListByOpenId();
    this.archivesDate = this.$dateFormat('YYYY-mm-dd', this.currentDate);
  },
  methods: {
    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let data = {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      };
      if (this.accountId != null && this.accountId != '') {
        data.accountId = this.accountId;
      }
      let result = await this.$http.get(this.$url.getTitle, data);
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data.title || '眼健康在线';
      }
    },
    onConfirmBirth(value) {
      this.birth = this.$dateFormat('YYYY-mm-dd', value);
      this.showBirth = false;
    },
    onConfirmArchives(value) {
      this.archivesDate = this.$dateFormat('YYYY-mm-dd', value);
      this.showArchives = false;
    },

    onConfirmName(value) {
      this.name = value.name;
      this.phone = value.phone;
      this.birth = value.birthday;
      this.showName = false;
    },
    async getListByOpenId() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getStudentsByOpenId, {
        openId: this.$route.query.openId,
        accountId: this.$route.query.accountId,
        auth: auth.code,
        time: auth.time
      });
      if (result.message === 'Error: Miss auth parameter.') {
        this.getListByOpenId();
      } else {
        this.listName = result.data.data;
      }
    },
    async goQuery() {
      if (this.name == "") {
        this.$toast("请填写姓名！");
        return;
      }
      if (this.birth == "") {
        this.$toast("请选择出生日期！");
        return;
      }
      if (this.archivesDate == "") {
        this.$toast("请选择建档日期！");
        return;
      }
      if (this.phone == "") {
        this.$toast("请填写手机号！");
        return;
      }

      if (this.phone != "") {
        let testPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[0123456789]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(this.phone)
        if (!testPhone) {
          this.$toast("手机号填写错误！");
          return;
        }
      }
      let result = await this.$http.get(this.$url.addWjSessionStudent, {
        name: this.name,
        sex: this.gender,
        birthday: this.birth,
        archivesDate: this.archivesDate,
        openId: this.openId,
        shortId: this.shortId,
        phone: this.phone
      })
      if (result.data && result.data.wjUrl) {
        let wjUrl = result.data.wjUrl;
        location.href = wjUrl;
      }
    }
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.btn {
  width: 5rem;
  margin-top: 1rem;
  border: none;
  background: #5CC4AB;
}

.tip {
  padding: 0.3rem;
  text-align: left;
  color: #999;
}

.ali-title {
  position: fixed;
  bottom: 0.5rem;
  left: 0;
  margin: 0.3rem;
  text-align: left;
  line-height: 1.5em;
}

.info-name-field {
  position: relative;
}

.field-sel {
  position: absolute;
  top: 0.1rem;
  left: 5.5rem;
  width: 1rem;
  padding: 0 0.1rem 0.05rem;
  border: 1px solid #ccc;
  color: #666;
  border-radius: 0.1rem;
}
</style>
